import React from "react";
import { FormSectionElements, FormSections, FormSubSections, LOVValues } from "../../entities/formTemplateDataType";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Editor } from "primereact/editor";

import { FR_SUFFIX } from "../../entities/Constants";
import { DialogBase } from "./DialogBase";

import { InputTextarea } from "primereact/inputtextarea";
import { getRootComponent } from "../../utilities/ElementUtils";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { getOtherFieldOptions } from "../..//utilities/ElementUtils";
import Utils from "../../utilities/Utils";
import { MultiSelect } from "primereact/multiselect";

interface Props {
    formSection: FormSections;
    field: FormSectionElements;
    isEng: boolean;
    callback;
}
interface State {
    confirmVisible: boolean;
    deleteIndex: number;
    dialogVisibleForRadioOptions: boolean[];
}

export class DropdownWithRichTextDesignComponent extends DialogBase<Props,State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            confirmVisible: false,
            deleteIndex: -1,
            dialogVisibleForRadioOptions: [],
        };
    }

    dropdownHtml = () => {
        let p = this.props.field;
        let container = getRootComponent(p);

        let elementListWithOptions = [];
        if (this.props.formSection.ListOfFormSubSections != null) {
            this.props.formSection.ListOfFormSubSections.forEach((subSection) => {
                let list = subSection.ListOfFormSectionElements.filter(
                    (q) =>
                        (q.Datatype === "RadioButton" ||
                            q.Datatype === "CheckGroup" ||
                            q.Datatype === "Dropdown") &&
                        q.Sequence < p.Sequence
                ).map((q) => {
                    return {
                        code: q.LoadBindName?.replace(/\s/g, ""),
                        description: this.props.isEng ? q.ENUTitle : q.FRATitle,
                    };
                });
                elementListWithOptions.push(...list);
            });
        }

        let htmlString = [];

        if (p.ListOfLOVValues == null) {
            p.ListOfLOVValues = [];
        }

        if (p.ListOfLOVValues.length === 0) {
            let lov=new LOVValues();
            lov.parent=p;
            p.ListOfLOVValues.push(lov);
        }

        htmlString.push(
            <button onClick={() => {
                p.displayInEditor = !p.displayInEditor;
                this.props.callback(container);
            }} >{p.displayInEditor==true ? "HTML":"Raw"}</button>)

        p.ListOfLOVValues.forEach((lov: LOVValues, index) => {
            htmlString.push(
                <div
                    style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "flex-start",
                        paddingTop: "5px",
                        alignItems: "center"
                    }}
                    key={"option_" + index}
                >
                    <div style={{ marginRight: "5px" }}>{index + 1}</div>
                    <div>
                        <i className="fa fa-regular fa-circle-dot"></i>
                    </div>
                    <div style={{ width: "10%" }}>
                        <InputText
                            className="ontario-input"
                            placeholder={"Code " + (index + 1).toString()}
                            value={lov.code}
                            onChange={(e) => {
                                lov.code = e.target.value;
                                this.props.callback(container);
                            }}
                        ></InputText>
                    </div>
                    <div style={{ width: "25%", marginLeft: "10px" }}>
                        <InputText
                            className="ontario-input"
                            placeholder={"Description " + (index + 1).toString()}
                            value={this.props.isEng? lov.description: lov.FRADescription}
                            onChange={(e) => {
                                if (this.props.isEng) { 
                                    if(Utils.willDefaultFR(lov.description,lov.FRADescription)){
                                        lov.FRADescription= Utils.isNullOrEmpty(e.target.value)? '':e.target.value + FR_SUFFIX;
                                    } 
                                    lov.description = e.target.value;
                                } else {
                                    lov.FRADescription = e.target.value
                                }
                                this.props.callback(container);

                            }}
                        ></InputText>
                    </div>

                    {p.displayInEditor && <div style={{ width: "60%" , marginLeft: "10px" }}>

                        {/* @ts-ignore */}
                        <Editor style={{ height: 'auto' }}
                            value={this.props.isEng ? lov.richText : lov.richTextFRA}
                            placeholder="Rich text"
                            onTextChange={(e) => {
                                if(this.props.isEng){
                                    if(Utils.willDefaultFR(lov.richText,lov.richTextFRA )){
                                        lov.richTextFRA = Utils.isNullOrEmpty(e.htmlValue)? '':e.htmlValue + FR_SUFFIX;
                                    } 
                                    lov.richText = e.htmlValue
                                }else{
                                    lov.richTextFRA = e.htmlValue;
                                }
                                this.props.callback(container);
                            }}></Editor>
                    </div>}
                    {p.displayInEditor || <div style={{ width: "60%" , marginLeft: "10px"}}>
                        {/* @ts-ignore */}
                        <InputTextarea style={{ height: 'auto' }}
                            value={this.props.isEng ? lov.richText : lov.richTextFRA}
                            placeholder="Rich text"
                            onChange={(e) => {
                                this.props.isEng
                                    ? (lov.richText = e.target.value)
                                    : (lov.richTextFRA = e.target.value);
                                this.props.callback(container);
                            }}></InputTextarea>
                    </div>}

                    {/* more option dialog only shows up for radio buttons, not dropdowns */}
                    {p.Datatype == "RadioButtonWithRichText" &&
                    <div style={{ marginLeft: "20px", marginTop: "10px", width: "10%" }} key={`moreOptions_${lov.code}`}>
                        <i
                            title="More Options"
                            className="pi pi-ellipsis-v"
                            style={{ fontSize: "1rem", cursor: "pointer" }}
                            onClick={(e) => {
                                this.state.dialogVisibleForRadioOptions[index] = true;
                                
                                this.setState({ dialogVisibleForRadioOptions: this.state.dialogVisibleForRadioOptions });
                            }}
                        />
                    </div>}


                    <div style={{ marginLeft: "10px" }}>
                        <i
                            title="Remove me"
                            className="pi pi-trash"
                            style={{ fontSize: "1rem", cursor: "pointer" }}
                            onClick={() => {
                                this.setState({ confirmVisible: true, deleteIndex: index });
                            }}
                        ></i>
                    </div>
                </div>
            );
            if (this.state.dialogVisibleForRadioOptions[index]) {
                htmlString.push(
                    <div>
                        {/* @ts-ignore */}
                        <Dialog
                            header={'Radio Button Options'}
                            visible={this.state.dialogVisibleForRadioOptions[index]}
                            footer={this.renderDialogFooter(index)}
                            style={{ width: '50vw' }}
                            onHide={() => {
                                this.state.dialogVisibleForRadioOptions[index] = false;
                                this.setState({ dialogVisibleForRadioOptions: this.state.dialogVisibleForRadioOptions });
                            }}
                        >
                            {this.generateFilterForLOVValue(lov)}
                        </Dialog>
                    </div>
                )
            }

        });




        htmlString.push(
            <div key={"addoption_" + p.Id}>
                {/* @ts-ignore */}
                <Button
                    className="p-button-rounded p-button-secondary"
                    style={{
                        cursor: "pointer",
                        margin: "5px",
                        fontSize: "90%",
                        border: "1px solid #64748B",
                        color: "#64748B",
                        background: "white"
                    }}
                    onClick={() => {
                        let newLov = new LOVValues();
                        newLov.Sequence = p.ListOfLOVValues.length;
                        newLov.parent=p;
                        p.ListOfLOVValues.push(newLov);
                        newLov.parent=p;
                        this.props.callback(container);
                    }}
                >
                    Add option
                </Button>
            </div>
        );

        return htmlString;
    };

    renderDialogFooter = (index: number) => {
        return (
            <div>
                {/* @ts-ignore */}
                <Button label="OK" icon="pi pi-check" onClick={() => {
                    this.state.dialogVisibleForRadioOptions[index] = false;
                    this.setState({ dialogVisibleForRadioOptions: this.state.dialogVisibleForRadioOptions });
                }} />
            </div>
        );
    }

    confirmRemove = () => {
        const { deleteIndex } = this.state;
        let p = this.props.field;
        p.ListOfLOVValues.splice(deleteIndex, 1);
        this.props.callback(getRootComponent(p));
        this.setState({ confirmVisible: false });
    };

    generateFilterForLOVValue = (lov: LOVValues) => {
        let html = [];
        let allElements = [];
        let elementListWithOptions = [];
        let container = getRootComponent(this.props.field);

        let subsection = this.props.field.parent as FormSubSections;
        //get elements to this element in the same subsection only
        let elementList = subsection.ListOfFormSectionElements.filter(p => p.Sequence < this.props.field.Sequence);
        allElements.push(...elementList);

        let list = allElements.filter(
            (q) =>
                (q.Datatype === "RadioButton" ||
                q.Datatype === "CheckGroup" ||
                q.Datatype === "Dropdown" ||
                q.Datatype === "RadioButtonWithRichText")
        ).map((q) => {
            return {
                code: q.LoadBindName,
                description: this.props.isEng ? q.ENUTitle : q.FRATitle
            };
        });

        elementListWithOptions.push(...list);
    
        if (lov.FilterField == null || lov.FilterField == undefined || !Array.isArray(lov.FilterField)) {
            lov.FilterField = [];
        }
        if (!lov.FilterValue || typeof lov.FilterValue !== 'object') {
            lov.FilterValue = {};
        }
        const filterValueMap = lov.FilterValue as Record<string, string[]>;
        let filterAdjusted = false;
        // remove filter fields if no field exists with the same LoadBindName
        for (let i = lov.FilterField.length - 1; i >= 0; i--) {
            if (!elementListWithOptions.find(ele => ele.code == lov.FilterField[i])) {
                lov.FilterField.splice(i, 1);
                filterAdjusted = true;
            }
        }
        // lov.FilterField = lov.FilterField.filter(f => !elementListWithOptions.find(ele => ele.code == f));

        for (let option of elementListWithOptions) {
        
            let optionList = allElements.filter(p => p.LoadBindName == option["code"])[0].ListOfLOVValues;
            if (lov.FilterField.indexOf(option["code"]) == -1) {
                lov.FilterField.push(option["code"])
            }

            const currentValues = Array.isArray(filterValueMap[option.code]) ? filterValueMap[option.code] : [];
            const validCodes = (optionList || []).map(v => v.code);
            const remappedValues = currentValues.map((val, idx) => {
                if (validCodes.includes(val)) return val;
                const positionalCode = optionList?.[idx]?.code;
                return positionalCode ?? null;
            }).filter(v => v != null) as string[];
            const sanitizedValues = remappedValues.filter(v => validCodes.includes(v));
            if (!optionList || !optionList.length) {
                delete filterValueMap[option.code];
                filterAdjusted = true;
            } else if (sanitizedValues.length !== currentValues.length) {
                filterValueMap[option.code] = sanitizedValues;
                filterAdjusted = true;
            }

            html.push(
                <>
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>Filtering Field</div>
                        <div style={{ width: '60%' }}>{this.props.isEng ? option["description"] : option["FRADescription"]}</div>
                    </div>
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>Filtering Value</div>
                        <div style={{ width: '60%', }}>
                            <div>
                                    {/* @ts-ignore */}
                                    <MultiSelect style={{ width: '100%' }}
                                        className="ontario-dropdown-small"
                                        options={optionList}
                                        value={filterValueMap ? filterValueMap[option.code] || [] : []}
                                        optionLabel={this.props.isEng ? "description" : "FRADescription"}
                                        optionValue="code"
                                        placeholder="Filtering value"
                                        onChange={(e) => {
                                            if (Utils.isNullOrEmpty(lov.FilterValue) || typeof lov.FilterValue == "string")
                                                lov.FilterValue = {};
                                            lov.FilterValue[option.code] = e.value || [];
                                            this.props.callback(container);
                                        }}
                                    />
                            </div>
                        </div>
                    </div>
                </>
            )


        }

        if (filterAdjusted) {
            this.props.callback(container);
        }
        return html;
    }

    render() {
        return (
            <div>
                {this.dropdownHtml()}
                {/* @ts-ignore */}
                <ConfirmDialog
                    visible={this.state.confirmVisible}
                    onHide={() => this.setState({ confirmVisible: false })}
                    message="Are you sure you want to remove this?"
                    header="Confirmation"
                    icon="pi pi-exclamation-triangle"
                    accept={this.confirmRemove}
                    reject={() => this.setState({ confirmVisible: false })}
                    closable={false}
                />
            </div>
        );
    }
}
